// Can't fully get rid of jQuery here since the carousel plugin needs it...
// TODO: Find a non-jQuery carousel replacement
import debounce from 'lodash.debounce';

const { $ } = window;

export default {
  data() {
    return {
      carousel: null,
      carouselHeight: '300px',
      carouselInitialized: false
    };
  },
  methods: {
    carouselNext() {
      this.carousel.carousel('next');
    },
    carouselPrev() {
      this.carousel.carousel('prev');
    },
    getTallestSlide() {
      const slides = Array.from(document.querySelectorAll('.carousel-item .col'));
      const slideHeights = slides.map(slide => slide.offsetHeight);

      this.carouselHeight = `${Math.max(...slideHeights) + 20}px`;
    },
    initCarousel() {
      this.carousel.carousel({
        dist: 0,
        full_width: false,
        indicators: true,
        padding: 0,
        shift: 40,
        time_constant: 200
      });

      this.scrollToRandomSlide();

      this.carouselInitialized = true;
    },
    onCarouselResize() {
      this.carouselInitialized = false;
      this.initCarousel();
    },
    scrollToRandomSlide() {
      const slideCount = document.querySelectorAll('.carousel-item').length;
      const startSlideNum = Math.floor(Math.random() * slideCount);
      this.carousel.carousel('next', startSlideNum);
    },
    start() {
      this.carousel = $('.carousel-slider');
      this.initCarousel();
    }
  },
  mounted() {
    window.addEventListener('resize', debounce(this.onCarouselResize, 500));

    this.getTallestSlide();
    this.start();
  },
  destroyed() {
    window.removeEventListener('resize', debounce(this.onCarouselResize, 500));
  }
};
